(function() {
  let isRunning = false;

  const getCartTotal = () => {
    const match = document.cookie.match(/pikolin_cart_total=(\d+)/);
    return match ? parseInt(match[1]) : 0;
  };

  window.applyClubLogic = function() {
    if (isRunning) return;
    isRunning = true;

    const totalCents = getCartTotal();
    const brutoCarrito = totalCents / 100;

    let volumeRate = 0;
    if (brutoCarrito >= 5000) volumeRate = 0.50;
    else if (brutoCarrito >= 3000) volumeRate = 0.45;
    else if (brutoCarrito >= 1500) volumeRate = 0.30;
    else if (brutoCarrito >= 500)  volumeRate = 0.15;

    const targets = document.querySelectorAll('.price-new[data-base-price]');
    const formatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

    targets.forEach(el => {
      const baseRaw = el.getAttribute('data-base-price');
      const currentHash = `${baseRaw}-${volumeRate}`;
      
      // Bloqueo de seguridad: Si el precio ya es correcto, no tocar el DOM
      if (el.getAttribute('data-applied-price') === currentHash) return;

      const precioPVP = parseFloat(baseRaw) / 100;
      const precioConClub = precioPVP;
      const precioFinal = precioConClub * (1 - volumeRate);
      const formattedPrice = formatter.format(precioFinal);

      const isCollection = el.closest('.layout-collection') !== null;
      let html = '';
      
      if (isCollection) {
        html = `<small style="font-size: 14px; font-weight: 400; color: #C4301C; margin-right: 2px;">Desde:</small>`;
        html += `<span style="font-size: 20px; font-weight: 700;">${formattedPrice}</span>`;
      } else {
        html = `<span style="font-size: 18px; font-weight: 700;">${formattedPrice}</span>`;
      }

      if (volumeRate > 0) {
        html += `<span style="display: block; font-size: 12px; color: #049B6E; font-weight: 400; text-align: right; margin-top:5px;">(Extra: -${Math.round(volumeRate * 100)}% aplicado)</span>`;
      }

      el.innerHTML = html;
      el.setAttribute('data-applied-price', currentHash); // Guardar estado
    });

    isRunning = false;
  };

  // Ejecución inicial rápida
  if (document.readyState === 'complete') window.applyClubLogic();
  else window.addEventListener('load', window.applyClubLogic);

  // Observer optimizado: Solo reacciona si cambian los precios
  const observer = new MutationObserver((mutations) => {
    if (isRunning) return;
    const shouldUpdate = mutations.some(m => m.addedNodes.length > 0 || m.type === 'attributes');
    if (shouldUpdate) window.applyClubLogic();
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: false });

  // Escucha de variantes con retraso para evitar colapsos
  document.addEventListener('click', (e) => {
    if (e.target.closest('.block-size__btn, variant-selects')) {
      setTimeout(window.applyClubLogic, 300);
    }
  });
})();